import React, {PureComponent} from "react";
import {connect} from "react-redux";
import {TopPanelProps} from "./TopPanelProps";
import {IApplicationState} from "../../../store";
import {animateTopPanel} from "./animateTopPanel";
import {HostElementRefProp} from "../HostElementRefProp";
import {cssHelper} from "../../utils/cssHelper";
import styles from "./top-panel.module.css";
import icons from "../../styles/icons.module.css";
import animations from "../../styles/animations.module.css";
import renderText from "../renderText";
import numDigits from "../../utils/numDigits";
import {watchAds} from "../../../store/advertisement/actions";
import getFontSize from "../../utils/getFontSize";
import {showDialog} from "../../../store/dialog-manager/actions";
import {showTutorial} from "../../../store/tutorial/actions";
import playSound from "../../sounds/playSound";
import i18n from "../../i18n";

export class TopPanel extends PureComponent<TopPanelProps & HostElementRefProp> {
    render() {
        const props = this.props;
        const fontSize = getFontSize(Math.max(numDigits(props.lives), numDigits(props.coins), numDigits(props.score)), 24, 40, 3, 6);
        const statsItemStyle = {
            fontSize
        };

        return (
            <div className={styles.top_panel} ref={props.hostElementRef}>
                <div>
                    <button className={cssHelper(styles.back_button, icons.back).toString()} onClick={() => this.click()}>Back</button>
                </div>

                <ul className={styles.stats}>
                    <li className={cssHelper(styles.stats_item, styles.lives).toString()} style={statsItemStyle} onClick={() => this.clickLives()}>
                        <i className={cssHelper(styles.icon, styles.lives_icon).add(animations.heart_beat, props.lives < props.maxLives).toString()}/>
                        <span className={styles.lives_value} style={{ minWidth: numDigits(props.lives) * (fontSize - 12) }}>{props.lives}</span>
                    </li>
                    <li className={`${styles.stats_item} ${styles.coins}`} style={statsItemStyle}>
                        <i className={`${styles.icon} ${styles.coins_icon}`}/>
                        <span className={styles.coins_value} style={{ minWidth: numDigits(props.coins) * (fontSize - 12) }}>{props.coins}</span>
                    </li>
                    <li className={`${styles.stats_item} ${styles.score}`} style={statsItemStyle}>
                        <i className={`${styles.icon} ${styles.score_icon}`}/>
                        <span className={styles.score_value} style={{ minWidth: numDigits(props.score) * (fontSize - 12) }}>{props.score}</span>
                    </li>
                </ul>

                <button disabled={!props.rewardedAdIsAvailable} className={cssHelper(styles.reward_button).add(animations.blink, props.rewardedAdIsAvailable).toString()} onClick={() => this.showRewardedAds()}>
                    <i className={`${styles.icon} ${icons.reward}`}/>
                    {renderText(i18n("gameplay.livesshop.watchbutton"), 10, 12, 9, 20, styles.reward_button_text)}
                </button>
            </div>
        );
    }

    componentDidMount(): void {
        if (!this.props.lives) {
            this.props.dispatch(showTutorial.request({
                selector: `.${styles.top_panel}`,
                title: "gameplay.levelmap.livestutor",
                delay: this.props.animate ? 1 : 0,
                closeOnTouch: true,
                propagateEvents: true,
            }));
        }
    }

    private click() {
        playSound("button-click");
        this.props.onBackButtonClick && this.props.onBackButtonClick();
    }

    private showRewardedAds() {
        playSound("button-click");
        this.props.dispatch(watchAds({
            adType: 'rewarded',
            reward: "coins"
        }));
    }

    private clickLives() {
        if (this.props.lives < this.props.maxLives) {
            this.props.dispatch(showDialog({ type: 'NoLivesDialog', options: {} }));
        }
    }
}

export default
    connect(({ player, advertisement, settings }: IApplicationState) => {
        return {
            lives: player.lives,
            coins: player.coins,
            score: player.score,
            rewardedAdIsAvailable: advertisement.rewardedAdIsAvailable,
            maxLives: settings.gameBalance.maxLives,
            animation: settings.animation,
        };
    })(animateTopPanel(TopPanel));